import * as React from 'react';
import { getIntrinsicElementProps, slot, useId, useMergedRefs } from '@fluentui/react-components';
import { useAnnounce_unstable as useAnnounceContext } from '@fluentui/react-shared-contexts';
import { useMessageAttributes } from '../../utils/useMessageAttributes';
/**
 * Create the state required to render UserMessage.
 *
 * The returned state can be modified with hooks such as useUserMessageStyles_unstable,
 * before being passed to renderUserMessage_unstable.
 *
 * @param props - props from this instance of UserMessage
 * @param ref - reference to root HTMLElement of UserMessage
 */
export const useUserMessage_unstable = (props, ref) => {
  const {
    announcement,
    accessibleHeading
  } = props;
  const messageId = useId('user-message-', props.id);
  const rootRef = React.useRef(null);
  const {
    announce
  } = useAnnounceContext();
  const {
    id,
    ...copilotChatAttributes
  } = useMessageAttributes({
    id: messageId
  });
  React.useEffect(() => {
    announcement && announce(announcement, {
      batchId: id
    });
  }, [announce, announcement, id]);
  return {
    components: {
      root: 'div',
      accessibleHeading: 'h5'
    },
    root: slot.always(getIntrinsicElementProps('div', {
      ref: useMergedRefs(rootRef, ref),
      id,
      ...copilotChatAttributes,
      ...props
    }), {
      elementType: 'div'
    }),
    accessibleHeading: slot.optional(accessibleHeading, {
      defaultProps: {
        children: 'You said: '
      },
      elementType: 'h5',
      renderByDefault: true
    })
  };
};
//# sourceMappingURL=useUserMessage.js.map